import CivilClusterPage from "./seo/CivilClusterPage";

// Preserve the existing canonical timesheet URL and its dedicated search intent.
export default function TimesheetAppNZ() {
  return <CivilClusterPage pageKey="timesheets" />;
}
